import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";

import DrawerPreviousSubmit from "components/form/DrawerPreviousSubmit";
import Error from "components/form/Error";
import SelectCityAll from "components/form/SelectCityAll";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import InputValue from "components/form/InputValue";
import Title from "components/form/Title";
import useVendorSubmit from "hooks/useVendorSubmit";
import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import RadioButton from "components/form/RadioButton";
import ActiveButton from "components/form/ActiveButton";
import { Select } from "@windmill/react-ui";
import Uploader from "components/image-uploader/Uploader";
import SelectStateSingle from "components/form/SelectStateSingle";
import SelectState from "components/form/SelectStaffState";
import SelectCity from "components/form/SelectCity";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import { FiX } from "react-icons/fi";
import InputName from "components/form/InputName";
import CheckboxGroupArea from "components/form/CheckBoxServiceType";
import SelectFranchise from "components/form/SelectFranchise";
import SelectServiceCity from "components/form/SelectFranchiseServiceCity";
import SelectServiceState from "components/form/selectFranchiseServiceState";
const VendorDrawer = ({ id, onModalOpen }) => {
  const [franchiseCities, setFranchiseCities] = useState([]);
 
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    handleNextStep,
    handlePreviousStep,
    errors,
    goToStep,
    step,
    idProofUrl,
    setIDProofUrl,
    panUrl,
    setPanUrl,
    gstUrl,
    setGstUrl,
    rcUrl,
    setRcUrl,
    checkLeafUrl,
    setCheckLeafUrl,
    selectedCompanyValue,
    selectedCity,
    selectedState,
    selectedProof,
    selectedCountryCode,
    selectedFranchise,
    handlefranchiseChange,
    handleChangeCompany,
    handleChangeProof,
    handleCityChange,
    handleStateChange,
    handleServiceChange,
    patternProof,
    palaceholderProof,
    selectedCities,
    setSelectedCities,
    selectedServiceState,
    setSelectedServiceState,
    selectedServices,
    franchiseError,
    loading,
  } = useVendorSubmit(id, onModalOpen);

  const handleCancelImage = (id) => {
    if (id === "proof") {
      setIDProofUrl("");
    } else if (id === "pan") {
      setPanUrl("");
    } else if (id === "rc") {
      setRcUrl("");
    } else if (id === "gst") {
      setGstUrl("");
    } else if (id === "check") {
      setCheckLeafUrl("");
    }
  };

  const tabs = [
    { tabValue: 1, labelName: "Basic Details" },
    {
      tabValue: 2,
      labelName: "Company Details",
    },
    { tabValue: 3, labelName: "ID Proof Details" },
    { tabValue: 4, labelName: "PAN & GST Details" },
    { tabValue: 5, labelName: "Bank Details" },
  ];

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? <Title title={"Edit Vendor"} /> : <Title title={"Add Vendor"} />}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          {tabs.map(({ tabValue, labelName, condition = true }) =>
            condition ? (
              <li key={tabValue}>
                <ActiveButton
                  tabValue={tabValue}
                  labelName={labelName}
                  goToStep={goToStep}
                  step={step}
                />
              </li>
            ) : null,
          )}
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {step === 1 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"Company Type"} />
                    <RadioButton
                      register={register}
                      name="company_type"
                      value1="Company"
                      value2="Non-Company"
                      label="Company Type"
                      selectedValue={selectedCompanyValue}
                      handleChange={handleChangeCompany}
                    />
                    <Error errorName={errors.company_type} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea required label={"Franchise"} />
                    <SelectFranchise
                      register={register}
                      trigger={trigger}
                      label="Franchise"
                      name="franchise"
                      selectedFranchise={selectedFranchise}
                      handlefranchiseChange={handlefranchiseChange}
                    />
                    {franchiseError && (
                      <span className="text-red-500 text-sm">
                        {franchiseError}
                      </span>
                    )}
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"State"} />
                    <SelectStateSingle
                      register={register}
                      label="State"
                      name="state"
                      selectedCountryId={110}
                      selectedState={selectedState}
                      handleStateChange={handleStateChange}
                    />
                    <Error errorName={errors.state} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"City"} />
                    <SelectCityAll
                      register={register}
                      label="City"
                      name="city"
                      selectedState={selectedState}
                      selectedCity={selectedCity}
                      handleCityChange={handleCityChange}
                    />
                    <Error errorName={errors.city} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"Address"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Company Address"
                      name="address"
                      minLength={10}
                      type="text"
                      placeholder={"123 Main Street, City, State"}
                    />
                    <Error errorName={errors.address} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Contact Person"} />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Full Name"
                      name="authorized_person"
                      type="text"
                      placeholder={"Jhon"}
                      minLength={3}
                      pattern={/^[a-zA-Z\s]+$/}
                    />
                    <Error errorName={errors.authorized_person} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Email"} />
                    <InputValue
                      trigger={trigger}
                      register={register}
                      label="Email"
                      name="email"
                      type="text"
                      placeholder={"jhon@gmail.com"}
                      pattern={
                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                      }
                    />
                    <Error errorName={errors.email} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Contact Number"} />
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      label="Mobile Number"
                      name="contact_no"
                      type="number"
                      minLength={10}
                      maxLength={10}
                      placeholder="9887564789"
                      pattern={/^\d{10}$/}
                      CountryCode={selectedCountryCode}
                      CountryCodeName="call_prefix"
                    />
                    <Error errorName={errors.contact_no} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Alternate Contact Number (Optional)"} />
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      required={false}
                      label="Alternate Contact Number"
                      name="al_contact_no"
                      type="number"
                      minLength={10}
                      maxLength={10}
                      placeholder="9992787897"
                      pattern={/^\d{10}$/}
                      CountryCode={selectedCountryCode}
                      CountryCodeName="al_call_prefix"
                    />
                    <Error errorName={errors.al_contact_no} />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea required label="Select Service State" />
                    <SelectState
                      onSelectState={setSelectedServiceState}
                      register={register}
                      name="service_state"
                      required={false}
                      selectedServiceState={selectedServiceState}
                      setSelectedServiceState={setSelectedServiceState}
                    />
                    <Error errorName={errors.service_state} />
                  </div> */}

                  {/* <div className="col-span-6">
                    <LabelArea required label="Select Service City" />
                    <SelectCity
                      name="service_city"
                      selectedCities={selectedCities}
                      selectedStates={selectedServiceState}
                      setSelectedCities={setSelectedCities}
                      selectedAllCityinState={selectedServiceState}
                      onSelectedAllStates={selectedServiceState}
                      onChange={setSelectedCities}
                    />

                    <Error errorName={errors.service_city} />
                  </div> */}




                   <div className="col-span-6">
                    <LabelArea required label="Select Service State" />
                    <SelectServiceState
                      onSelectState={setSelectedServiceState}
                      register={register}
                      name="service_state"
                      required={false}
                      selectedServiceState={selectedServiceState}
                      selectedFranchise={selectedFranchise}
                      setSelectedServiceState={setSelectedServiceState}
                      from={'franchise_partner'}
                      setFranchiseCities={setFranchiseCities}
                    />
                    <Error errorName={errors.service_state} />
                  </div>
 
                  <div className="col-span-6">
                    <LabelArea required label="Select Service City" />
                    <SelectServiceCity
                      name="service_city"
                      selectedCities={selectedCities}
                      selectedStates={selectedServiceState}
                      setSelectedCities={setSelectedCities}
                      selectedAllCityinState={selectedServiceState}
                      onSelectedAllStates={selectedServiceState}
                      onChange={setSelectedCities}
                      franchiseCities={franchiseCities}
                    />
 
                    <Error errorName={errors.service_city} />
                  </div>

                  <div className="col-span-6 ">
                    <LabelArea required label={"Refered By"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Refered by"
                      name="refered_by"
                      placeholder={"Friend"}
                      type="text"
                      maxLength={120}
                      pattern={/^[a-zA-Z\s]+$/}
                    />
                    <Error errorName={errors.refered_by} />
                  </div>

                  <div className="col-span-6 pt-3">
                    <LabelArea required label={"Services"} />
                    <CheckboxGroupArea
                      register={register}
                      name="service_type"
                      label="Service Type"
                      required={true}
                      options={[
                        { value: "OutStation", label: "Outstation" },
                        { value: "Holiday Package", label: "Holiday Package" },
                        { value: "Hour Rental", label: "Hour Rental" },
                        { value: "Airport Pickup", label: "Airport Pickup" },
                        { value: "Airport Drop", label: "Airport Drop" },
                         { value: "Oneway", label: "Oneway"},
                      ]}
                      selected={selectedServices}
                      onChange={handleServiceChange}
                    />
                    <Error errorName={errors.service_type} />
                  </div>

                  {id ? (
                    <div className="col-span-6">
                      <LabelArea required label={"Password"} />
                      <InputArea
                        trigger={trigger}
                        register={register}
                        label="Password"
                        name="password"
                        placeholder={"Enter Password"}
                        type="text"
                        maxLength={120}
                      />
                      <Error errorName={errors.password} />
                    </div>
                  ) : null}
                </div>

                <DrawerCancelNext handleNextStep={handleNextStep} />
              </>
            )}
            {step === 2 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-12">
                    <LabelArea required label={"Company Name"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Company Name"
                      name="company_name"
                      type="text"
                      minLength={3}
                      placeholder={"Company name"}
                      // pattern={/^[a-zA-Z0-9\s]+$/}
                    />
                    <Error errorName={errors.company_name} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"Pincode"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Pincode"
                      name="pincode"
                      type="number"
                      maxLength={6}
                      placeholder={"606889"}
                      pattern={/^\d{6}$|^\d{3}\s\d{3}$/}
                    />
                    <Error errorName={errors.pincode} />
                  </div>
                </div>

                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 3 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"Proof Type"} />
                    <Select
                      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
                      {...register(`proof_type`, {
                        required: !selectedProof
                          ? `Proof Type is required!`
                          : false,
                      })}
                      label="Proof Type"
                      name="proof_type"
                      defaultValue={selectedProof}
                      onChange={(e) => handleChangeProof(e.target.value)}
                      onBlur={() => trigger("proof_type")}
                    >
                      <option value={""}>Select Proof</option>
                      <option value={"Aadhar"}>Aadhar</option>
                      <option value={"Passport"}>Passport</option>
                      <option value={"Voter ID"}>Voter ID</option>
                    </Select>
                    <Error errorName={errors.proof_type} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Name in Proof"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Name in Proof"
                      name="name_in_proof"
                      type="text"
                      placeholder={"Jhon"}
                      minLength={3}
                      pattern={/^[A-Za-z. ]+$/}
                    />
                    <Error errorName={errors.name_in_proof} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Proof ID Number"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Proof ID Number"
                      name="id_proof"
                      type="text"
                      placeholder={palaceholderProof}
                      pattern={patternProof}
                    />
                    <Error errorName={errors.id_proof} />
                  </div>

                  <div className="col-span-8">
                    <LabelArea required label={"ID Proof"} />
                    {idProofUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            borderRadius: "10px",
                            height: "100px",
                          }}
                          src={process.env.REACT_APP_API_IMAGE_URL + idProofUrl}
                          alt="caricon"
                        />
                        <FiX
                          size={25}
                          onClick={() => {
                            handleCancelImage("proof");
                          }}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={true}
                        folder="vendor"
                        name_merge="VENDOR_IDProof"
                        imageUrl={idProofUrl}
                        setImageUrl={setIDProofUrl}
                        no_of_image={2}
                      />
                    )}

                    <Error errorName={errors.idProofUrl} />
                  </div>
                </div>

                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 4 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"PAN Number"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="PAN Number"
                      name="pan_no"
                      type="text"
                      placeholder={"ABCTY1234D"}
                      capitalize={true}
                      pattern={/[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                    />
                    <Error errorName={errors.pan_no} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"PAN Card"} />
                    {panUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            borderRadius: "10px",
                            height: "100px",
                          }}
                          src={process.env.REACT_APP_API_IMAGE_URL + panUrl}
                          alt="caricon"
                        />
                        <FiX
                          size={25}
                          onClick={() => {
                            handleCancelImage("pan");
                          }}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vendor"
                        name_merge="VENDOR_PAN"
                        imageUrl={panUrl}
                        setImageUrl={setPanUrl}
                        no_of_image={1}
                      />
                    )}
                    <Error errorName={errors.panUrl} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"RC Image (Optional)"} />
                    {rcUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            borderRadius: "10px",
                            height: "100px",
                          }}
                          src={process.env.REACT_APP_API_IMAGE_URL + rcUrl}
                          alt="caricon"
                        />
                        <FiX
                          size={25}
                          onClick={() => {
                            handleCancelImage("rc");
                          }}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vendor"
                        name_merge="VENDOR_RC"
                        imageUrl={rcUrl}
                        setImageUrl={setRcUrl}
                        no_of_image={1}
                      />
                    )}
                    <Error errorName={errors.rcUrl} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"GST No  (Optional)"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      required={false}
                      label="GST No"
                      name="gst"
                      type="text"
                      placeholder={"22AAAAA0000A1Z5"}
                      pattern={
                        /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z\d]{1}$/
                      }
                    />
                    <Error errorName={errors.gst} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"GST Certificate  (Optional)"} />
                    {gstUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            borderRadius: "10px",
                            height: "100px",
                          }}
                          src={process.env.REACT_APP_API_IMAGE_URL + gstUrl}
                          alt="caricon"
                        />
                        <FiX
                          size={25}
                          onClick={() => {
                            handleCancelImage("gst");
                          }}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vendor"
                        name_merge="VENDOR_GST"
                        imageUrl={gstUrl}
                        setImageUrl={setGstUrl}
                        no_of_image={1}
                      />
                    )}

                    <Error errorName={errors.gstUrl} />
                  </div>
                </div>

                <DrawerPreviousNext
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
            {step === 5 && (
              <>
                <div className="grid grid-cols-12 gap-4 mb-6">
                  <div className="col-span-6">
                    <LabelArea required label={"Account Number"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Account Number"
                      name="account_no"
                      type="text"
                      placeholder={"635802010014976"}
                      pattern={/^\d{5,18}$/}
                    />
                    <Error errorName={errors.account_no} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"Beneficiary Name"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Beneficiary Name"
                      name="beneficiary_name"
                      type="text"
                      minLength={3}
                      placeholder={"Jhon"}
                      pattern={/^[A-Za-z. ]+$/}
                    />
                    <Error errorName={errors.beneficiary_name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label={"IFSC Code"} />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="IFSC Code"
                      name="ifsc_code"
                      type="text"
                      capitalize={true}
                      placeholder={"SBIN0005943"}
                      pattern={/^[A-Z]{4}0[A-Z0-9]{6}$/}
                    />
                    <Error errorName={errors.ifsc_code} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea required label={"Canceled Check Leaf"} />
                    {checkLeafUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            borderRadius: "10px",
                            height: "100px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + checkLeafUrl
                          }
                          alt="caricon"
                        />
                        <FiX
                          size={25}
                          onClick={() => {
                            handleCancelImage("check");
                          }}
                        />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vendor"
                        name_merge="VENDOR_CheckLeaf"
                        imageUrl={checkLeafUrl}
                        setImageUrl={setCheckLeafUrl}
                        no_of_image={1}
                      />
                    )}

                    <Error errorName={errors.checkLeafUrl} />
                  </div>
                </div>

                <DrawerPreviousSubmit
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
          </div>

          {/* <DrawerButton id={id} title='Submit'/> */}
        </form>
      </Scrollbars>
    </>
  );
};

export default VendorDrawer;
